import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
    Box,
    Typography,
    TextField,
    Button,
    List,
    ListItem,
    IconButton,
    FormHelperText,
    Paper
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { convertGenderText } from '../utils/consts';

const ActionPlanSection = ({ onNext, formData }) => {
    const [newStep, setNewStep] = useState('');
    const { handleSubmit, formState: { errors }, setValue, watch } = useForm({
        defaultValues: {
            plan_dzialania_kroki: [],
            plan_dzialania_dodatkowe_mysli: ''
        }
    });

    const steps = watch('plan_dzialania_kroki');
    const goalMappings = {
        "Szukam pierwszej pracy": "znalezienia pierwszej pracy",
        "Szukam pracy": "znalezienia pracy",
        "Myślę o znalezieniu innej/nowej pracy": "decyzji o szukaniu innej pracy",
        "Wracam na rynek pracy": "powrocie na rynek pracy",
        "Przekwalifikowuje się": "przekwalifikowaniu się"
    }
    const processGoal = goalMappings[formData.cel_wybor] || formData.cel_wybor;




    const getNextStepQuestion = (stepIndex) => {
        if (stepIndex === 0) {
            return `Jaki pierwszy krok ${convertGenderText('mógłbyś/abyś', formData.zwrot_plec)} zrobić już dzisiaj, który przybliżyłby Cię do ${processGoal}?`;
        } else if (stepIndex === 1) {
            return "A jaki w drugiej kolejności?";
        } else if (stepIndex === 2) {
            return "I co jeszcze?";
        } else {
            return "I następne?";
        }
    };

    const handleAddStep = () => {
        if (newStep.trim()) {
            setValue('plan_dzialania_kroki', [...steps, newStep.trim()]);
            setNewStep('');
        }
    };

    const handleRemoveStep = (index) => {
        setValue('plan_dzialania_kroki', steps.filter((_, i) => i !== index));
    };

    return (
        <Box component="form" onSubmit={handleSubmit(onNext)} sx={{ mt: 3 }}>
            <Typography variant="h6" color="black" gutterBottom>
                {getNextStepQuestion(steps.length)}
            </Typography>

            <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                    <TextField
                        fullWidth
                        value={newStep}
                        onChange={(e) => setNewStep(e.target.value)}
                        placeholder="Wpisz tutaj..."
                    />
                    <Button
                        onClick={handleAddStep}
                        disabled={!newStep.trim() || steps.length >= 15}
                        color="primary"
                    >
                        Dodaj krok
                    </Button>
                </Box>

                <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                    <List>
                        {steps.map((step, index) => (
                            <ListItem
                                key={index}
                                secondaryAction={
                                    <IconButton
                                        edge="end"
                                        aria-label="delete"
                                        onClick={() => handleRemoveStep(index)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                }
                            >
                                {`${index + 1}. ${step}`}
                            </ListItem>
                        ))}
                    </List>
                </Paper>

                {errors.plan_dzialania_kroki && (
                    <FormHelperText error>
                        {errors.plan_dzialania_kroki.message}
                    </FormHelperText>
                )}
            </Box>

            {/* <Controller
                name="plan_dzialania_dodatkowe_mysli"
                control={control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        fullWidth
                        multiline
                        rows={4}
                        label="Dodatkowe przemyślenia dotyczące Twojego planu działania (opcjonalne)"
                        sx={{ mb: 3 }}
                    />
                )}
            /> */}

            <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={steps.length < 4}
            >
                Zakończ
            </Button>
        </Box>
    );
};

export default ActionPlanSection; 